// Where to land after an OAuth round trip. A cookie rather than the OAuth state because the
// state is minted by the API, which has no business knowing a web route.
export const POST_AUTH_DESTINATION_COOKIE = 'post_auth_destination'

const UNFINISHED_ACCOUNT_EXIT: Record<string, string> = {
  unverified: '/auth/verify-email',
  invited: '/accept-invite',
}

/** The cookie a page sets before handing someone to their provider, so they come back here. */
export function postAuthDestinationCookie(destination: string): string {
  return `${POST_AUTH_DESTINATION_COOKIE}=${encodeURIComponent(destination)}; path=/; max-age=600; samesite=lax`
}

// A shell organisation is not a destination: claiming one is a subscription, so asking for it
// here would be an upsell (CONTEXT.md → Claiming an Organisation).
export function postAuthDestination(session: {
  accountStatus?: string | null
  requiresOrgSetup?: boolean
  destination?: string | null
}): string {
  const { accountStatus } = session
  if (accountStatus && accountStatus !== 'active') {
    return UNFINISHED_ACCOUNT_EXIT[accountStatus] ?? '/auth/signin'
  }
  return withinApp(session.destination) ? session.destination! : '/'
}

// A destination survives an OAuth round trip in a cookie, so it is attacker-writable: only a
// path inside this app is honoured.
function withinApp(destination?: string | null): boolean {
  return !!destination && destination.startsWith('/') && !/^\/[/\\]/.test(destination)
}

export function refusedSignInDestination(error?: string | null): string {
  const reason =
    (error ?? '').trim() || 'We could not complete that sign in. Please try again.'
  return `/auth/signin?error=${encodeURIComponent(reason)}`
}
